/**
 * Loại combobox
 * NVTUAN1 22.11.2023
 */
export default {
  ComboNotColumns: 1, //combo không có columns (ComboEditor)
  ComboColumns: 2, //combo có columns
  ComboTree: 3, //combo tree
};